// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__37Rhc","colCheckbox":"styles_colCheckbox__125RP"};